import { useCreateCompanyPreferenceMutation } from '../redux/apis/companyPreference.api';
import { createResetBizviewPeriodsPayload } from './companyPreferenceUtils';

/**
 * Hook to reset company preferences for Current Period and Compare Period
 * @returns Object with reset function and loading state
 */
export const useResetBizviewPeriods = () => {
  const [createCompanyPreference, { isLoading }] = useCreateCompanyPreferenceMutation();

  const resetBizviewPeriods = async (): Promise<void> => {
    try {
      const resetPayloads = createResetBizviewPeriodsPayload();
      
      // Reset both Current Period and Compare Period preferences
      await Promise.all(
        resetPayloads.map((payload) => createCompanyPreference(payload).unwrap())
      );
    } catch (error) {
      console.error('Failed to reset company preferences:', error);
      throw error;
    }
  };

  return {
    resetBizviewPeriods,
    isLoading,
  };
};

